// Nothing here yet (Figma "Empty state"): an icon, what's missing, and the one
// thing that fills it.
import * as React from 'react';
import { Sparkles } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from './Button';

export function EmptyState({ title, body, icon: Icon = Sparkles, action, className }) {
  return (
    <div className={cn('flex flex-col items-center rounded-[20px] border border-border-subtle bg-bg-surface px-6 py-8 text-center', className)}>
      <span className="mb-2.5 inline-flex h-[46px] w-[46px] items-center justify-center rounded-full bg-accent-tint text-accent-default">
        <Icon size={22} aria-hidden="true" />
      </span>
      <h3 className="m-0 type-label-section text-text-primary">{title}</h3>
      {body ? <p className="m-0 mt-2.5 max-w-sm type-body-small text-text-secondary">{body}</p> : null}
      {action ? <Button kind="secondary" size="small" onClick={action.onClick} className="mt-4">{action.label}</Button> : null}
    </div>
  );
}
